import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

type PlusIconProps = SvgIconProps & {
  minus?: boolean
}

export function PlusIcon({ minus, ...props }: PlusIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d={minus ? 'M12 12V12' : 'M12 5V19'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`transition-d duration-100 ease-linear`}
      />
      <path
        d="M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
